import { render } from "./PreviousReports.vue?vue&type=template&id=d7c88e60&scoped=true"
import script from "./PreviousReports.vue?vue&type=script&lang=js"
export * from "./PreviousReports.vue?vue&type=script&lang=js"

import "./PreviousReports.vue?vue&type=style&index=0&id=d7c88e60&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7c88e60"]])

export default __exports__